





export class McComponent extends HTMLElement {
  constructor() {
    super()
  }
}



if (!window.customElements.get("mc-c")) {
  window.customElements.define("mc-c", McComponent)
}
